import React from 'react';

const BillToSection = ({ client, onClientChange }) => {
  const handleChange = (field, value) => {
    onClientChange({
      ...client,
      [field]: value,
    });
  };

  return (
    <div className="mb-10" id="bill-to-section">
      <h2 className="text-lg font-bold text-gray-800 mb-2">BILL TO</h2>
      <div className="text-sm text-gray-600 space-y-1">
        <input
          type="text"
          id="client-name-input"
          value={client.name}
          onChange={(e) => handleChange('name', e.target.value)}
          className="block border-b my-0.5 pb-0.5"
        />
        <input
          type="text"
          id="client-company-input"
          value={client.company}
          onChange={(e) => handleChange('company', e.target.value)}
          className="block border-b my-0.5 pb-0.5"
        />
        <input
          type="text"
          id="client-address-input"
          value={client.address}
          onChange={(e) => handleChange('address', e.target.value)}
          className="block border-b my-0.5 pb-0.5"
        />
        <input
          type="text"
          id="client-city-state-zip-input"
          value={client.cityStateZip}
          onChange={(e) => handleChange('cityStateZip', e.target.value)}
          className="block border-b my-0.5 pb-0.5"
        />
      </div>
    </div>
  );
};

export default BillToSection;